import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Event } from "../../../../../models/event";
import { EventType } from "../../../../../models/event-type";
import { Registration } from "../../../../../models/registration";
import { DeterminantService } from "../../../../../services/registration-controller/determinant.service";
import { RegistrationControllerService } from "../../../../../services/registration-controller/registration-controller.service";
import { DocumentResultControllerService } from "../../../../../services/result-controller/document-result-controller.service";
import { Store } from "../../../../../services/store.service";
import { BaseError } from "../../../base-error";
import { TranslatedBaseError } from "../../../TranslatedBaseError";
import { TranslateService } from "@ngx-translate/core";

import { RecoverOrphanConfig } from "../../../../../models/recover-orphan-config";

@Component({
  selector: "registration-determinant",
  templateUrl: "./determinant-registration.component.html",
  styles: [],
  providers: [DocumentResultControllerService, ToastrService],
})
export class RegistrationDeterminantComponent extends TranslatedBaseError implements OnInit, OnChanges, OnDestroy {

  @Input() public registration: Registration;
  @Input() public serviceId: string;
  @Input() public smallView: boolean;
  @Input() public disabled: boolean = false;
  @Input() public determinantMapById: { [key: string]: string };
  @Input() public debugErrors: RecoverOrphanConfig[] = [];
  @Output() public modalClosedEvent = new EventEmitter();
  @Output() public openDeterminantBuilderModal = new EventEmitter();
  public showOptionalDeterminantBuilderModal: boolean;
  public showMandatoryDeterminantBuilderModal: boolean;
  public determinantCountMandatory: number;
  public determinantCountOptional: number;
  public showDeterminant: boolean = false;
  public isCollapsed: boolean = false;
  public subscription: any;

  constructor(private registrationController: RegistrationControllerService,
    private determinantService: DeterminantService,
    public store: Store,
    toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.subscription = this.determinantService.updateDeterminant.subscribe((data) => {
      this.registration = data.registration;
      this.saveRegistration();
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public errors: { [key: string]: boolean } = {};

  // ...

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.serviceId && changes.serviceId.currentValue) {
      this.serviceId = changes.serviceId.currentValue;
    }
    if (changes.registration && changes.registration.currentValue) {
      this.registration = changes.registration.currentValue;
    }
    if (changes.debugErrors) {
      this.calculateErrors();
    }
  }

  private calculateErrors() {
    this.errors = {};
    if (this.debugErrors) {
      this.errors.missing_determinants_in_registration_mandatory = this.debugErrors.some(e => (e.objectType === 'missing_determinants_in_registration_mandatory') && (e.objectId === this.registration.id));
      this.errors.missing_determinants_in_registration_optional = this.debugErrors.some(e => (e.objectType === 'missing_determinants_in_registration_optional') && (e.objectId === this.registration.id));
    }
    console.log('Calculating errors with debugErrors:', this.debugErrors, 'Resulting errors:', this.errors);
  }

  public eventCloseRegistrationDeterminantWindow(doReload: boolean) {
    if (doReload) {
      this.getRegistration();
      this.modalClosedEvent.emit(new Event(undefined, EventType.Update));
    }
  }

  public clearFormula(confirmation: boolean, type: string) {
    if (!this.disabled && confirmation) {
      if (type === "optionalDeterminants") {
        this.registration.optionalJsonDeterminants = '[{"type":"OR","items":[]}]';
      } else if (type === "mandatoryDeterminants") {
        this.registration.mandatoryJsonDeterminants = '[{"type":"OR","items":[]}]';
      }
      this.saveRegistration();
    }
  }

  public hasDeterminant(item) {
    if (!item || item === '[{"type":"OR","items":[]}]') {
      return false;
    }
    return true;
  }

  public saveRegistration() {
    if (!this.disabled) {
      this.registrationController.saveRegistration(this.serviceId, this.registration).subscribe(
        () => {
          this.getRegistration();
          this.responseSuccessful("Registration determinant saved!");
        },
        (error) => {
          this.getRegistration();
          return this.showErrorMessage(error);
        },
      );
    }
  }

  public getRegistration() {
    if (this.registration && this.registration.id) {
      this.registrationController.getRegistration(this.registration.id).subscribe(
        (data) => {
          this.registration = data;
        },
        (error) => {
          return this.showErrorMessage(error);
        },
      );
    }
  }

  public initSectionData(type: string) {
    const determinantService = {
      serviceId: this.serviceId,
      registration: this.registration,
      type,
      jsonString: this.registration[type],
    };
    this.store.state.common.sections.active = true;
    this.store.state.common.sections.type = "determinant";
    console.log('Determinant section initialized with type:', type);
    this.openDeterminantBuilderModal.emit(determinantService);
  }
}
